import React, { Component } from 'react'
import { Card, Table, Pagination } from 'antd'
import PropTypes from 'prop-types'
import { API_GET_USER_DEVICES } from './../../../api'
import moment from 'moment'

const columns = [
  {
    title: 'Device name',
    dataIndex: 'deviceName',
    key: 'deviceName',
  },
  {
    title: 'Created',
    dataIndex: 'createdAt',
    key: 'createdAt',
    render: text => (
      <div>
        <div className="block">{moment(text).format('DD MMM YYYY, HH:mm')}</div>
      </div>
    ),
  },
  {
    title: 'Last update',
    dataIndex: 'updatedAt',
    key: 'updatedAt',
    render: text => (
      <div>
        <div className="block">{moment(text).format('DD MMM YYYY, HH:mm')}</div>
      </div>
    ),
  },
  {
    title: 'Note',
    dataIndex: 'note',
    key: 'note',
  },
]

class Devices extends Component {
  constructor(props) {
    super(props)
    this.state = {
      devices: [],
      currentPage: 1,
    }
  }

  componentDidMount() {
    API_GET_USER_DEVICES(this.props.userId).then(res =>
      this.setState({ ...this.state, devices: res.data }))
  }

  render() {
    const { devices, currentPage } = this.state
    return (
      <div>
        <Card className="table-responsive">
          <div>
            <Table
              dataSource={devices}
              columns={columns}
              rowKey="deviceUniqueId"
              pagination={false}
            />
            <div className="app-pagination">
              <Pagination
                current={currentPage}
                total={devices.length}
              />
            </div>
          </div>
        </Card>
      </div>
    )
  }
}

Devices.defaultProps = {
  userId: 0,
}

Devices.propTypes = {
  userId: PropTypes.string,
}

export default Devices



// WEBPACK FOOTER //
// src/pages/user/devices/index.js